import { render, staticRenderFns } from "./Sheji.vue?vue&type=template&id=1dc79bc9&scoped=true"
import script from "./Sheji.vue?vue&type=script&lang=js"
export * from "./Sheji.vue?vue&type=script&lang=js"
import style0 from "./Sheji.vue?vue&type=style&index=0&id=1dc79bc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc79bc9",
  null
  
)

export default component.exports